import type { QueryClient } from '@tanstack/react-query'

import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { NuqsAdapter } from 'nuqs/adapters/tanstack-router'

const RootLayout = () => (
	<NuqsAdapter>
		<Outlet />
		<TanStackRouterDevtools position='bottom-right' />
	</NuqsAdapter>
)

type MyRouterContext = {
	queryClient: QueryClient
}
export const Route = createRootRouteWithContext<MyRouterContext>()({
	component: RootLayout,
})
